import React from "react";
import { Link } from "react-router-dom";
import {
  BUSINESS_NAME,
  BUSINESS_EMAIL,
  BUSINESS_MOBILE,
  BUSINESS_ADDRESS,
  LOGO_URL,
} from "../lib/site";

export const SiteFooter = () => {
  return (
    <footer className="bg-slate-950 text-white py-12 border-t border-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 border-b border-slate-900 pb-12">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Logo" className="w-10 h-10 rounded-full border border-slate-800" />
              <span className="font-extrabold text-md uppercase tracking-tight">{BUSINESS_NAME}</span>
            </div>
            <p className="text-xs text-slate-400 font-medium leading-relaxed">
              Premium DTF transfers, wholesale plain t-shirt manufacturing, and zero-investment Print-on-Demand for clothing brands across India.
            </p>
          </div>

          <div>
            <h4 className="font-extrabold text-xs uppercase tracking-widest text-slate-300 mb-4">Our Services</h4>
            <ul className="space-y-2 text-xs text-slate-400 font-mono uppercase">
              <li><Link to="/premiumtshirtmanufacturing" className="hover:underline hover:text-white">Plain T-Shirt Manufacturing</Link></li>
              <li><Link to="/dtf" className="hover:underline hover:text-white">DTF Gang Sheets</Link></li>
              <li><Link to="/POD" className="hover:underline hover:text-white">Print On Demand</Link></li>
              <li><Link to="/admin" className="hover:underline hover:text-white">Dashboard</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-extrabold text-xs uppercase tracking-widest text-slate-300 mb-4">Contact Info</h4>
            <ul className="space-y-2 text-xs text-slate-400 font-mono">
              <li>Email: {BUSINESS_EMAIL}</li>
              <li>Phone: +91 {BUSINESS_MOBILE}</li>
              <li className="leading-relaxed">Address: {BUSINESS_ADDRESS}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-extrabold text-xs uppercase tracking-widest text-slate-300 mb-4">Why Us</h4>
            <p className="text-xs text-slate-400 leading-relaxed font-medium">
              80+ wash guarantee, soft hand-feel prints, premium fabrics, fast dispatch from NCR, and dedicated brand support. Trusted by 100+ brands.
            </p>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row justify-between items-center text-xs text-slate-500 font-mono">
          <p>© {new Date().getFullYear()} {BUSINESS_NAME}. All rights reserved.</p>
          <p className="mt-2 sm:mt-0">Made with precision for custom apparel makers.</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
